import styled from '@emotion/styled';

export const ProfileMenuHeaderImageContainer = styled.div`
  flex: 0 0 60px;
  height: 60px;
  width: 60px;
  background: ${props => props.theme.colors.beige[0]};
  border-radius: 100%;
`;
